import React from 'react';
import Image from 'react-bootstrap/Image';
import profileIcon from '../../../images/profile.png';

function ProfileImage() {
    
    return  <Image src={profileIcon} fluid alt="profil-ikon"/>;
    
}
export default ProfileImage;